// installation-deactivate.guard.ts
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface ComponentWithDeactivate {
  onExit: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class InstallationDeactivateGuard implements CanDeactivate<ComponentWithDeactivate> {
  canDeactivate(component: ComponentWithDeactivate): boolean {
    // call component hook
    if (component.onExit) {
      component.onExit();
    }
    return true; // always allow navigation
  }
}
